import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchPaymentScheduleDates = createAsyncThunk(
  "payment-schedule-dates/fetch",
  async () => {
    const response = await API.get("/payment_schedule_dates")

    return response.data.payment_schedule_dates
  },
)
